import PermissionGuard from 'components/Global/PermissionGuard';
import PayPointComponent from 'components/Settings/Masters/PayPoint';

export const PayPoint = () => {
	return (
		<PermissionGuard permission="Allow_Pay_Point">
			<PayPointComponent />
		</PermissionGuard>
	);
};
